import React, { Suspense, useEffect, useState } from 'react';
import { getMfDialog, RemoteDialogProps } from '@im/ui-lib/mf-utils';
import { useLocation } from 'react-router-dom';
import { ScopeProvider } from '../provider';
import { useCancelAllDialogs, useCurrentDialogInfo } from './internal.hooks';
import { useCloseDialog } from './remote-dialog.hooks';

export function RenderRemoteDialog() {
  const remoteDialogInfo = useCurrentDialogInfo();
  const cancelAllDialogs = useCancelAllDialogs();
  const closeDialog = useCloseDialog();
  const location = useLocation();
  const { pathname } = location;

  const [Dialog, setDialog] = useState<
    React.FC<RemoteDialogProps> | undefined
  >();

  // cancelAllDialogs on pathname change
  useEffect(() => {
    cancelAllDialogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (!remoteDialogInfo) {
      setDialog(undefined);
      return;
    }
    let active = true;

    (async () => {
      const [mfName, dialogId] = remoteDialogInfo.dialogId.split('.');
      const dialog = await getMfDialog(mfName, dialogId);
      if (active) {
        // https://github.com/facebook/react/issues/19098
        setDialog(() => dialog);
      }
    })();
    return () => {
      active = false;
    };
  }, [remoteDialogInfo]);

  if (!remoteDialogInfo || !Dialog) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ScopeProvider scope={remoteDialogInfo.dialogId}>
        <Dialog
          dialogParams={remoteDialogInfo?.dialogParams}
          onClose={(answer?: unknown) => {
            closeDialog(answer);
          }}
        />
      </ScopeProvider>
    </Suspense>
  );
}
